import { render, staticRenderFns } from "./DriversItinerary.vue?vue&type=template&id=5818068c&scoped=true&"
import script from "./DriversItinerary.vue?vue&type=script&lang=js&"
export * from "./DriversItinerary.vue?vue&type=script&lang=js&"
import style0 from "./DriversItinerary.vue?vue&type=style&index=0&id=5818068c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818068c",
  null
  
)

export default component.exports